// OPTIONS

export const INVENTORY_LOCATIONS = [
  {
    label: 'Purchased - At Source Location (PSL)',
    value: 1
  },
  {
    label: 'Purchased - In Transit (PIT)',
    value: 2
  },
  {
    label: 'Incoming New Vehicle from Factory (INC)',
    value: 5
  }
];

export const PURCHASE_METHOD = [
  {
    label: 'Trade',
    value: 1
  },
  {
    label: 'Purchase',
    value: 2
  }
];

// ENUMS

export const INVENTORY_SOURCE_IDS = {
  PURCHASE_FROM_CUSTOMER_FOR_INVENTORY: 3,
  MANUFACTURER: 4,
  PURCHASE_FROM_OTHER: 6,
  TRADE: 7,
  DEALER_DX: 8
};

export const LOCATION_TYPE_IDS = {
  CAD: 3
};

// OPTION KEYS

export const INVENTORY_SOURCE_OPTION_KEYS = {
  label: 'inventory_source',
  value: 'inventory_source_id'
};

export const SALES_USER_OPTION_KEYS = {
  label: 'name',
  value: 'site_user_id'
};

export const INVENTORY_LOCATIONS_OPTION_KEYS = {
  label: 'inventorylocation_type_name',
  value: 'inventorylocation_type_id'
};

export const VEHICLE_MAKES_OPTION_KEYS = {
  label: 'vehicle_make_name',
  value: 'vehicle_make_id'
};

export const WARRANTY_TYPES_OPTION_KEYS = {
  label: 'warranty_type_name',
  value: 'warranty_type_id'
};

export const VENDOR_OPTION_KEYS = {
  label: 'vendor_name',
  value: 'dsl_vendor_id'
};

// LOOKUP PARAMS

export const LOOKUP_PARAMS = {
  salesStaff: {
    charkey: 'SLSSTF'
  },
  salesManagerStaff: {
    charkey: 'SLSMGR'
  }
};

// STATUS
export const INVENTORY_STATUS = {
  backout: 'Backout',
  delivered: 'Delivered',
  fallout: 'Fallout',
  funded: 'Funded',
  inStock: 'In Stock',
  order: 'Order',
  preStock: 'Pre Stock',
  returned: 'Returned',
  returnedFunded: 'Returned Funded',
  sold: 'Sold',
  wsDelivered: 'WS Delivered',
  wsFunded: 'WS Funded'
};
